/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Unified lifecycle status across every competition type, used by the browse surface. Each type's native status maps onto exactly one of these. DRAFT, PAUSED and CANCELLED are never returned by the public browse feed.
 * 
 * @export
 */
export const NormalizedCompetitionStatus = {
    DRAFT: 'DRAFT',
    UPCOMING: 'UPCOMING',
    OPEN: 'OPEN',
    LIVE: 'LIVE',
    COMPLETED: 'COMPLETED',
    PAUSED: 'PAUSED',
    CANCELLED: 'CANCELLED'
} as const;
export type NormalizedCompetitionStatus = typeof NormalizedCompetitionStatus[keyof typeof NormalizedCompetitionStatus];


export function instanceOfNormalizedCompetitionStatus(value: any): boolean {
    for (const key in NormalizedCompetitionStatus) {
        if (Object.prototype.hasOwnProperty.call(NormalizedCompetitionStatus, key)) {
            if (NormalizedCompetitionStatus[key as keyof typeof NormalizedCompetitionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NormalizedCompetitionStatusFromJSON(json: any): NormalizedCompetitionStatus {
    return NormalizedCompetitionStatusFromJSONTyped(json, false);
}

export function NormalizedCompetitionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): NormalizedCompetitionStatus {
    return json as NormalizedCompetitionStatus;
}

export function NormalizedCompetitionStatusToJSON(value?: NormalizedCompetitionStatus | null): any {
    return value as any;
}

export function NormalizedCompetitionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): NormalizedCompetitionStatus {
    return value as NormalizedCompetitionStatus;
}

